export enum DocumentTypeUserEnum {
    /**
     * Ficha Cadastral
     */
    FC = "870c005a-c174-4353-851e-9627d1197b90",
    /**
     * RG/CNH
     */
    RGCNH = "2341dd2b-f3f5-4c52-8452-a4e1ba320866",
    /**
     * Comprovante de Endereço
     */
    CE = "2f12965b-d0da-4a0e-8d71-4822111cac8e",
    /**
     * Certidão de Nascimento
     */
    CN = "abc270e1-4da8-4608-bb00-b9f0f381a2bd",
    /**
     * Procuração
     */
    PRO = "92689d78-0289-4dcf-bb40-ba426e8b8d0f",
    /**
     * Contrato Social
     */
    CS = "d0809f6d-aada-4da5-8523-1a882069e226",
    /**
     * Estatuto Social
     */
    ES = "0fe9df5e-08b9-47b5-9c7d-4d00ccf33e63",
    /**
     * Balanço e DRE
     */
    BDRE = "15b1b31b-b455-47b4-81f2-969d0da37b0d",
    /**
     * OTA
     */
    OTA = "ec0bae35-c7e7-4c29-8214-106d0eef02d3",
    /**
     * STVM
     */
    STVM = "9cdae327-ec6d-4a40-8e7d-76a528a93ec4",
    /**
     * Cartão CNPJ
     */
    CCNPJ = "8ed06ff8-d89e-4ba9-91da-9d86cbed6513",
    /**
     * Organograma
     */
    ORG = "e66c07d8-4cf6-4272-b535-947486e4065e",
    /**
     * KYC
     */
    KYC = "300aa041-8358-4193-bf71-be864518036c",
    /**
     * Outros
     */
    OTHERS = "97fd8943-2086-4f49-8dca-4415e316791c",
    /**
     * Documento de indentificação e CPF dos Representantes
     */
    DICPFREP = "81c4d9c1-c01a-489e-b1c5-44504d5711e2",
    /**
     * Contrato Social ou última alteração consolidada
     */
    CDUAC = "ed481239-458b-4750-b1e3-9d8eecfe0474",
    /**
     * Documento de identificação dos Diretores e/ou Procuradores nomeados em ata
     */
    DIDP = "1084bcaf-1885-464b-9a21-3f20261ad16f",
    /**
     * Cópia da declaração Conforme. (Simples)
     */
    CDCS = "503fbe4d-be55-464c-bfb9-40b7e449d8c9",
    /**
     * Imagem de um documento com CPF do cotitular
     */
    CPFCO = "586c89a1-8882-4a82-877f-39911bb2aa69",
    /**
     * Imagem do cartão de débito do cotitular
     */
    CDEBCO = "7826f1fd-ec23-4ea9-80da-a1a541ff3fef",
    /**
     * Imagem do cartão de débito do titular
     */
    CDEBTI = "c245836d-c733-4f18-84c4-de4c6d5b53ef",
    /**
     * Imagem da folha de cheque
     */
    CHQ = "d6fcdcbf-41dc-4308-bee8-aa8e0b48442a",
    /**
     * Declaração de patrimônio líquido e faturamento médio mensal(assinada pelo contador e representante)
     */
    DPLFMM = "05f051bf-4fd9-4f5b-9e1a-59481d5f1472"
}